export const normalizeText = (text) => {
  if (text === null || text === undefined) return '';
  return text
    .toString()
    .toLowerCase()
    .normalize('NFD') // Decompose combined characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics/accents
    .trim();
};

export const intelligentSearch = (query, ...fields) => {
  if (!query || !query.trim()) return true; // Empty query matches everything
  
  const normalizedQuery = normalizeText(query);
  const searchTerms = normalizedQuery.split(/\s+/); // Split query by spaces
  
  // Combine all fields into a single normalized string for searching
  const combinedFields = fields
    .filter(f => f !== null && f !== undefined)
    .map(f => normalizeText(f))
    .join(' ');

  // Every term in the search query must be found somewhere in the combined fields
  return searchTerms.every(term => combinedFields.includes(term));
};

export const prepareSearchTerms = (rawQuery) => {
  if (!rawQuery) return [];
  // Remove commas, parentheses, quotes, backslashes and reserved PostgREST delimiters
  const cleaned = rawQuery.replace(/[,()"\\]/g, ' ').trim();
  return cleaned.split(/\s+/).filter(t => t.length > 0);
};

export const sanitizePostgrestTerm = (term) => {
  if (!term) return '';
  return term.replace(/[%_,()"\\]/g, '').trim();
};

